import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { ref } from "vue";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderStatus',
  setup(__props) {

  const kumaEndpoint = ref(process.env.VUE_APP_KUMA_ENDPOINT);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("iframe", {
    class: "w-full h-full",
    src: kumaEndpoint.value
  }, null, 8, _hoisted_1))
}
}

})